export default {
    bannerOption: {
        speed: 2000,
        autoplay: 4000,
    },


    productOption: {
        speed: 1000,
        prevButton: ".product-prev",
        nextButton: ".product-next",
        isBeginning: false,
        isEnd: false,
        activeIndex: 0,
        onSlideChangeStart: function(swiper) {
            this.isBeginning = swiper.isBeginning;
            this.isEnd = swiper.isEnd;
            this.activeIndex = swiper.activeIndex;
            console.log('123')
        },
        onInit: function(swiper) {
            this.isBeginning = swiper.isBeginning;
            this.isEnd = swiper.isEnd;
            this.activeIndex = swiper.activeIndex;
        },
        onSlideChange: function(e) {
            console.log('1123')
        }
    },

}


// WEBPACK FOOTER //
// ./src/view/options.js